import { create } from 'zustand';
import { CartItem } from 'types/cart';
type State = { initialized: boolean; items: CartItem[] };

type Actions = {
  addItemToCart: (item: CartItem) => void;
  removeItemFromCart: (itemId: string) => void;
  setInitialized: (initialized: boolean) => void;
  reset: () => void;
};

export const useCartStore = create<State & Actions>((set, get, store) => ({
  initialized: false,
  items: [],
  setInitialized: (initialized: boolean) => set(() => ({ initialized })),
  addItemToCart: (item: CartItem) => set((state) => ({ items: [...state.items, item] })),
  removeItemFromCart: (itemId: string) => set((state) => ({ items: state.items.filter((item) => item.id !== itemId) })),
  reset: () => set(store.getInitialState()),
}));
